import React from "react";
import bannerImg from "../../assets/images/seobanner.png";
import "../../styles/Webdevelopment.css";
import { Link } from "react-router-dom";

function seobanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>SEO Agency in Noida for Result-Driven Digital Growth</h1>
          <p>
            In these days’s competitive on line market, having a robust virtual
            presence is crucial for commercial enterprise achievement. Whether
            you run a startup, small business, or corporation, partnering with a
            reliable <b>seo agency in Noida </b> can help you enhance
            visibility, and generate awesome leads.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>SEO Service</span>
      </div>
    </div>
  );
}

export default seobanner;
